import React from "react";
import ReactDOM from "react-dom";
//import "core-js/es6/map";
//import "core-js/es6/set";
import "raf/polyfill";
import "@babel/polyfill";
import { Provider } from "react-redux";
import store from "./store/index";
import "./eytheme.scss";

import MainContainer from "components/containers/MainContainer";
import { MLPUBLICAPI } from "./apiPublic";
// Our translated strings

var apiPublic = new MLPUBLICAPI();

const DO_NOT_LOGIN = true;

ReactDOM.render(
  <Provider store={store}>
    <MainContainer />
  </Provider>,
  document.getElementById("root")
);
